module.exports = __webpack_public_path__ + "static/media/icon-chevron-down.c66b213d.svg";